
import { defineComponent, PropType, ref, toRefs, watch, reactive } from "vue";
import { ElDivider, ElInput, ElCheckbox, ElButton, ElIcon, ElMessage } from "element-plus";
import { ArrowDown, ArrowUp } from "@element-plus/icons-vue";

import {
    getCommentList,
    doCreateComment,
    CommentCreateFormData,
    CommentCreateInfo,
} from "@/services";
import {
    AlbumModel,
    ArtistModel,
    CommentModel,
    CommentTargetType,
    ArtistId,
    AlbumId,
    RankId,
    ArticleId,
} from "@/typings";

export default defineComponent({
    components: {
        ElInput,
        ElDivider,
        ElCheckbox,
        ElButton,
        ElIcon,
        ArrowDown,
        ArrowUp,
    },
    props: {
        targetId: {
            type: String,
            required: true,
            default: "",
        },
        targetType: {
            type: String as PropType<CommentTargetType>,
            required: true,
            default: "ALBUM",
        },
        commentInfo: {
            type: Object as PropType<CommentCreateInfo>,
            required: false,
            default: null,
        },
    },
    emits: ["change"],
    setup(props, { emit }) {
        const { targetType, targetId, commentInfo } = toRefs(props);
        const isShow = ref(false);

        const formEdit = reactive<CommentCreateFormData>({
            content: "",
            is_anon: false,
            is_private: false,
        });
        const doSendComment = async () => {
            if (formEdit.content.length > 100) {
                ElMessage.error(`限制最长100字，目前长度为${formEdit.content.length}`);
                return false;
            }
            const json = await doCreateComment(
                targetType.value,
                targetId.value,
                props.commentInfo,
                formEdit,
            );
            console.log(json);
            formEdit.content = "";
            ElMessage.success("提交成功！");
            emit("change", json.data.comment);
        };
        const toggleExpand = () => {
            isShow.value = !isShow.value;
        };
        return {
            formEdit,
            isShow,
            doSendComment,
            toggleExpand,
        };
    },
});
